import { render, staticRenderFns } from "./export-sale-invoice-list-settings-modal.vue?vue&type=template&id=6b4e861a&scoped=true"
import script from "./export-sale-invoice-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./export-sale-invoice-list-settings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e861a",
  null
  
)

export default component.exports